export const auth = {
  login: 'Bejelentkezés',
  register: 'Regisztráció',
  resetPassword: 'Jelszó visszaállítása',
  loginSubtitle: 'Jelentkezz be az ügyfeleid kezeléséhez',
  registerSubtitle: 'Hozz létre egy új fiókot',
  resetSubtitle: 'Add meg az e-mail címed a jelszó visszaállításához',
  email: 'E-mail cím',
  password: 'Jelszó',
  displayName: 'Név',
  emailRequired: 'Az e-mail cím megadása kötelező',
  passwordRequired: 'A jelszó megadása kötelező',
  displayNameRequired: 'A név megadása kötelező',
  invalidEmail: 'Érvénytelen e-mail formátum',
  passwordTooShort: 'A jelszó legalább 6 karakter hosszú legyen',
  forgotPassword: 'Elfelejtetted a jelszavadat?',
  noAccount: 'Nincs még fiókod? Regisztrálj!',
  backToLogin: '← Vissza a bejelentkezéshez',
  processing: 'Feldolgozás...',
  signInWithGoogle: 'Bejelentkezés Google-fiókkal',
  acceptTerms: 'A folytatással elfogadod a YouCRM',
  termsOfService: 'Felhasználási feltételeit',
  and: 'és',
  privacyPolicy: 'Adatvédelmi szabályzatát',
  or: 'vagy'
};
